let _config = null;

export function setRuntimeConfig(config) {
  _config = config;
}

export function getRuntimeConfig() {
  return _config ?? {};
}
